var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7032e28ec240ec3a4a938ff7be03296e9ca87f62"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website-next@upflow"]={id:"7032e28ec240ec3a4a938ff7be03296e9ca87f62"};
      